import React from 'react';
import { EshopsComponentsTitles } from '@mshops-components-library/common';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var VALID_ESHOP_TYPES = ['seller', 'affiliate', 'brand'];
var typeEshop = function typeEshop(eshopType) {
  return Boolean(eshopType && VALID_ESHOP_TYPES.includes(eshopType));
};
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var getChildren = function getChildren(children, _ref) {
  var moreProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return children === null || children === void 0 ? void 0 : children.map(function (child) {
    var _child$props, _child$props2;
    var newProps = _objectSpread2(_objectSpread2({}, (_child$props = child.props) === null || _child$props === void 0 || (_child$props = _child$props.node) === null || _child$props === void 0 ? void 0 : _child$props.properties), moreProps);
    var newChild = /*#__PURE__*/React.cloneElement(child, {
      node: _objectSpread2(_objectSpread2({}, (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.node), {}, {
        properties: newProps
      })
    });
    return newChild;
  });
};
var getChildren$1 = getChildren;
var RelevantItemContainer = function RelevantItemContainer(_ref) {
  var _EshopsComponentsTitl, _h;
  var title = _ref.title,
    device = _ref.device,
    eshopType = _ref.eshopType,
    cta = _ref.cta,
    metrics = _ref.metrics,
    _ref$show_title = _ref.show_title,
    showTitle = _ref$show_title === void 0 ? true : _ref$show_title,
    children = _ref.children;
  var namespace = 'ui-relevant-item-container';
  var showTitles = function showTitles() {
    return typeEshop(eshopType) ? _EshopsComponentsTitl || (_EshopsComponentsTitl = /*#__PURE__*/_createRawReactElement(EshopsComponentsTitles, {
      showTitle: showTitle,
      title: title,
      deviceType: device,
      titleClassName: "".concat(namespace, "__title")
    })) : _h || (_h = /*#__PURE__*/_createRawReactElement("h2", {
      className: "".concat(namespace, "__title")
    }, void 0, title));
  };
  return /*#__PURE__*/_createRawReactElement("div", {
    className: "".concat(namespace)
  }, void 0, showTitles(), getChildren$1(children, {
    device: device,
    cta: cta,
    metrics: metrics
  }));
};
var RelevantItemContainer$1 = RelevantItemContainer;
export { RelevantItemContainer$1 as RelevantItemContainer, RelevantItemContainer$1 as default };
